var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0001 16.2963H10.0001C9.45005 16.2963 9.00005 15.8463 9.00005 15.2963V10.2963H7.41005C6.52005 10.2963 6.08005 9.21625 6.71005 8.58625L11.3001 3.99625C11.4869 3.809 11.7405 3.70377 12.0051 3.70377C12.2696 3.70377 12.5232 3.809 12.7101 3.99625L17.3001 8.58625C17.9301 9.21625 17.4801 10.2963 16.5901 10.2963H15.0001V15.2963C15.0001 15.8463 14.5501 16.2963 14.0001 16.2963ZM18 14.9999C18 14.4476 18.4477 13.9999 19 13.9999C19.5523 13.9999 20 14.4476 20 14.9999V18.9999C20 19.0521 19.996 19.1034 19.9883 19.1534C19.996 19.2001 20 19.2478 20 19.2963C20 19.8463 19.4857 20.2963 18.8571 20.2963H5.14286C4.51429 20.2963 4 19.8463 4 19.2963C4 19.2478 4.004 19.2001 4.01171 19.1534C4.004 19.1034 4 19.0521 4 18.9999V14.9999C4 14.4476 4.44772 13.9999 5 13.9999C5.55228 13.9999 6 14.4476 6 14.9999V18.2963H18V14.9999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.bf88f1251deea03643b1dc534a096de3.svg";
export { ForwardRef as ReactComponent };